<template>
    <v-card>
        <v-card-title>
        <span class="headline">Ajouter Consignataire</span>
        </v-card-title>
        <v-card-text>
        <v-container>
            <v-row>
            <v-col cols="12" sm="6" md="6">
                <v-text-field label="Code Consignataire*" disabled v-model="consigTmp.code" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="consigTmp.nom" label="Nom&Prénom Consignataire"></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="consigTmp.titre_pro" label="Profession*" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
                <v-text-field v-model="consigTmp.mat_fiscale" label="Matricule Fiscale" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field v-model="consigTmp.tel" label="Telephone" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field v-model="consigTmp.email" label="Email" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field v-model="consigTmp.adresse" label="Adresse" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field v-model="consigTmp.fax" label="Fax" required></v-text-field>
            </v-col>
            </v-row>
        </v-container>
        <small>*toutes les cases indiquées avec étoiles sont obligatoires</small>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">Fermer</v-btn>
        <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="addConsig">Ajouter</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: 'add-consig',
    data: () => ({
        snackbar: false,
        snackbarText: '',
        color: "success",
        consigTmp: {code: null},
    }),
    mounted() {
        this.axios
            .get('/consig/listing')
            .then(response => {
                if(response.data.length > 0){
                    var nextCode = response.data.reduce((max, p) => p.code > max ? p.code : max, response.data[0].code)
                if(Number(nextCode.slice(0, 4)) === new Date().getFullYear() ) {
                    nextCode = Number(nextCode)+1
                }else{
                    nextCode = new Date().getFullYear()+'0001';
                }
                }else{
                    nextCode = new Date().getFullYear()+'0001';
                }
                this.consigTmp.code = nextCode
            })
        
    },
    methods: {
        closeDialog(){
            this.$emit('close', true)
        },
        addConsig(){
            this.axios.post('/consig/create', this.consigTmp, {
            }).then((res) => {
                if(res.data === 'error'){
                this.color = "error"
                this.snackbarText = "Essayez de remplir tous les champs obligatoires."
                this.snackbar = true
                }else{
                this.color = "success"
                this.snackbarText = "Le consignataire a été ajouté avec succès."
                this.snackbar = true
                this.$emit('reloadData', true)
                this.closeDialog()
                }
                
            }).catch(e => {
                this.color = "error"
                this.snackbar = true
                this.snackbarText = "Un erreur est survenu, essayez plus tard."
                console.log(e)
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/dashboard/database/consig/add.component.vue